import { render, staticRenderFns } from "./EstadisticaPrincipal.vue?vue&type=template&id=629350fe&"
import script from "./EstadisticaPrincipal.vue?vue&type=script&lang=js&"
export * from "./EstadisticaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports